import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { ComponentPlaceholder } from '@thd-olt-component-react/loading-placeholder';
import { dataModel } from './dataModel';
import {
  ItemRelatedGroupsPropType,
  ItemRelatedGroupsDefaultProps,
} from './Helper';

const placeholder = (
  <ComponentPlaceholder
    height={400}
    rows={10}
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./ItemRelatedGroupsDesktop')).ItemRelatedGroupsDesktop;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "irg-desktop" */
      './ItemRelatedGroupsDesktop');
  },
  placeholder,
  name: 'ItemRelatedGroupsDesktop',
});

const HydratedComponent = withHydrator({
  delay: 1500,
  id: 'product-section-irg',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);

export const ItemRelatedGroupsDesktopImporter = withErrorBoundary(DynamicComponent);

ItemRelatedGroupsDesktopImporter.displayName = 'ItemRelatedGroupsDesktopImporter';

ItemRelatedGroupsDesktopImporter.dataModel = dataModel;

ItemRelatedGroupsDesktopImporter.propTypes = ItemRelatedGroupsPropType;

ItemRelatedGroupsDesktopImporter.defaultProps = ItemRelatedGroupsDefaultProps;
